import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { Position } from 'coreOld/enums';

interface IProps {
  label: string;
  htmlFor?: string;
  required?: boolean;
  labelPosition?: Position;
}

interface LabelStyledProps {
  labelPosition?: Position;
  htmlFor?: string;
  children?: ReactNode;
}

export const LabelStyled = styled.label<LabelStyledProps>`
  ${({ labelPosition }) => {
    switch (labelPosition) {
      case Position.LEFT:
        return css`
          font-size: 16px;
        `;
      case Position.TOP:
        return css`
          font-size: 10px;
          font-weight: 400;
          letter-spacing: 0.05em;
          color: ${({ theme }) => theme.palette.neutral.dark};
          text-transform: uppercase;
        `;
      default:
        return css``;
    }
  }};
`;

export const Div = styled.div`
  margin-bottom: 5px;
  margin-top: 5px;
`;

const LabelView = ({ label, htmlFor, required, labelPosition = Position.TOP }: IProps) => {
  if (!label) {
    return null;
  }

  const htmlForProps = htmlFor ? { for: htmlFor, id: htmlFor } : {};

  return (
    <Div>
      <LabelStyled {...htmlForProps} labelPosition={labelPosition}>
        {required ? `${label} *` : label}
      </LabelStyled>
    </Div>
  );
};

export default LabelView;
